import { NgIf } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { UserResponse } from '../../../models/responses/user-response';
import { UserService } from '../../../services/user.service';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { pathNames } from '../../../utilities/routing-path-utils';
import { Router } from '@angular/router';

@Component({
  selector: 'app-all-users-list-component',
  standalone: true,
  imports: [
    MatTableModule,
    MatIconModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatPaginatorModule,
    MatSortModule,
    MatDividerModule,
    NgIf
  ],
  templateUrl: './all-users-list.component.html',
  styleUrl: './all-users-list.component.scss'
})
export class AllUsersListComponent {
  dataSource!: MatTableDataSource<UserResponse>;
  isLoading: boolean = false;
  displayedColumns: string[] = ['First Name', 'Last Name', 'Email', 'Has payed', 'View'];
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private userService: UserService,
    private router: Router
  ) {
    this.dataSource = new MatTableDataSource();
  }

  ngOnInit(){
    this.fetchAllUsers();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  fetchAllUsers(){
    this.userService.fetchAllUsersForAdmin().subscribe({
      next: users => {
        this.dataSource.data = users;
      },
      error: () => {
        alert('Server Error contact support')
      }
    })
  }

  onViewUser(user: UserResponse) {
    this.router.navigate(['/' + pathNames.aiAgentConfigurationPath + '/' + user.id]);
  }
}
